module.exports = __webpack_public_path__ + "media/images/countrysquared/fo-40a0880d3dd399f272e83ebeefa2fc65.svg";